import { render, staticRenderFns } from "./TicketsBoardColumn.vue?vue&type=template&id=181b76ce&scoped=true&"
import script from "./TicketsBoardColumn.vue?vue&type=script&lang=js&"
export * from "./TicketsBoardColumn.vue?vue&type=script&lang=js&"
import style0 from "./TicketsBoardColumn.vue?vue&type=style&index=0&id=181b76ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181b76ce",
  null
  
)

export default component.exports